import NewPayStudentsPage from './new-paytudents-page'

export default NewPayStudentsPage
